<template>
  <div>
    <HeadlineContainer headline="My Focus" :breadcrumbs="[]"/>

    <div class="container">
      <div class="row">
        <div class="col-sm-10">
          <Greeting/>

          <div class="row">
            <div class="col-sm-12">
              <TaskCount/>
            </div>

            <div class="col-sm-12">
              <OpportunityCount/>
            </div>
          </div>

          <ContentNotificationList/>

          <RetentionTouchpointsWidget/>

          <MeetingsWidget/>

          <OnlineUserList/>
        </div>

        <div class="col-sm-14">
          <CompetitionsPanel/>

          <TaskList/>

          <OpportunityList/>

          <MyMeetingsWidget/>

          <MyProjectsWidget/>

          <ReminderList/>

          <ContentList v-if="hasPermission('admin')"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContentList from '@/pages/Dashboards/MyFocus/Panels/ContentList'
import Greeting from '@/pages/Dashboards/MyFocus/Panels/Greeting'
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import MeetingsWidget from '@/components/Dashboards/MyFocus/Panels/MeetingsWidget'
import MyMeetingsWidget from '@/components/Dashboards/MyFocus/Panels/MyMeetingsWidget'
import OnlineUserList from '@/pages/Dashboards/MyFocus/Panels/OnlineUserList'
import OpportunityCount from '@/pages/Dashboards/MyFocus/Panels/OpportunityCount'
import OpportunityList from '@/pages/Dashboards/MyFocus/Panels/OpportunityList'
import Permissions from '@/mixins/Permissions'
import ReminderList from '@/pages/Dashboards/MyFocus/Panels/ReminderList'
import TaskCount from '@/pages/Dashboards/MyFocus/Panels/TaskCount'
import TaskList from '@/pages/Dashboards/MyFocus/Panels/TaskList'
import CompetitionsPanel from '../../../components/Dashboards/MyFocus/Panels/CompetitionsPanel'
import MyProjectsWidget from "../../../components/Dashboards/MyFocus/Panels/MyProjectsWidget.vue"
import ContentNotificationList from "./Panels/ContentNotificationList.vue"
import RetentionTouchpointsWidget from '@/pages/Dashboards/MyFocus/Panels/RetentionTouchpointsWidget'

export default {
  components: {
    ContentNotificationList,
    MyProjectsWidget,
    CompetitionsPanel,
    ContentList,
    Greeting,
    HeadlineContainer,
    MeetingsWidget,
    MyMeetingsWidget,
    OnlineUserList,
    OpportunityCount,
    OpportunityList,
    ReminderList,
    TaskCount,
    TaskList,
    RetentionTouchpointsWidget
  },

  mixins: [Permissions]
}
</script>